<div class="exercise">
  <img src="./../../../assets/images/SVG/winco_isotipo.svg" />
  <section class="info">
    <h3>{{ exercise.name }}</h3>

    <ul class="table">
      <li class="cell">
        <h4>{{ 'objetivo' | translate }}</h4>
        <p>{{ exercise.description }}</p>
      </li>
      <li *ngIf="penalties.length > 0" class="cell">
        <h4>{{ 'penalizaciones' | translate }}</h4>
        <ul class="penalties">
          <li *ngFor="let penalty of penalties">{{ penalty }}</li>
        </ul>
      </li>
      <li *ngIf="equipment.length > 0" class="cell">
        <h4>{{ 'materiales' | translate }}</h4>
        <ul class="equipment">
          <li *ngFor="let equip of equipment">{{ equip }}</li>
        </ul>
      </li>
    </ul>
    <div class="footer">
      <div class="info-box">
        <span>{{ 'max_tiempo' | translate }}: {{ exercise.timeLimit ?? 0 | numbertotime }} min</span>
        <span>{{ 'repeticiones' | translate }}: {{ exercise.numReplays }}/{{ environment.maxExerciseRepeat }}</span>
      </div>
      <div *ngIf="exercise.numReplays >= environment.maxExerciseRepeat" class="error-repetitions">
        {{ 'superado_max_repeticiones' | translate }}
      </div>

      <button (click)="hideModal()" class="submit">{{ 'continuar' | translate | uppercase }}</button>
    </div>
  </section>
</div>
